import { isProd } from 'utils/config';

export const STAKE_CONFIG = isProd()
  ? {
      contractAddress: '0xFA21807EDE5486c83d665812525ff44C5B72F3ED',
    }
  : {
      contractAddress: '0x734039f88A7C5aBb5C7198cf5D142b42aD085dFF',
    };
